module.exports = __webpack_public_path__ + "img/logo.d6845d1f.svg";